import { Injectable, EventEmitter } from '@angular/core';
import { VisitEmitType } from '@fs/models/agreement/visit.model';
import { EvetnEmitModel } from '@shared/models/event-emit.model';
@Injectable()
export class DataSharingLTE {
    public TaxGroupDataChangeEvent = new EventEmitter();
    public PaymentTermChangeEvent = new EventEmitter();
    public OrderStatusChangeEvent = <any>new EventEmitter();
    public itemChangeEvent = new EventEmitter();
    public CloseSettingChildTabEvent =new EventEmitter();
    public EquipmentWarrantyChangeEvent = new EventEmitter();
    public WOListRefreshed = new EventEmitter();
    public RefreshWoReviewForAgreement = <any>new EventEmitter();
    public visitChangeEvent = new EventEmitter();

    taxGroupDataChanged(data:any){
        this.TaxGroupDataChangeEvent.emit(data)
    }
    paymentTermChangeEvent(data:any){
        this.PaymentTermChangeEvent.emit(data)
    }
    equipmentWarrantyChangeEvent(data:any){
        this.EquipmentWarrantyChangeEvent.emit(data)
    }
    WOSChangeEvent(data:any){
        this.OrderStatusChangeEvent.emit(data)
    }
    ItemChangeEvent(){
        this.itemChangeEvent.emit();
    }
    closeSettingChildTabEvent(data:any){
        this.CloseSettingChildTabEvent.emit(data);
    }
    woListRefreshed(data: any) {
        this.WOListRefreshed.emit(data);
    }
    emitWoReviewRefresh(data: any) {
        this.RefreshWoReviewForAgreement.emit(data);
    }
    emitVisitChange(data: EvetnEmitModel<VisitEmitType>) {
        this.visitChangeEvent.emit(data);
    }
}